import React, { useState, useEffect, useContext } from "react";



function FormField(props) {
    return (
        <div className="researcher-sign-up-form-field">
            <label className="researcher-sign-up-form-field-label">{props.label}</label>
            <input className="researcher-sign-up-form-field-input"
                name={props.name} value={props.value}
                onChange={(event) => props.onChange(event)}
                placeholder={props.placeholder}
                autoComplete={props.autoComplete}
                required={props.required}
                type={props.type || "text"}
            />
            {props.errorMessage && <div className="researcher-sign-up-form-field-error">{props.errorMessage}</div>}
        </div>
    )
}

function DropdownQuestion(props) {
    const [isActive, setIsActive] = useState(false);

    const handleChange = (value) => {
        setIsActive(value !== "-1");
        props.onChange(value);
    };

    return (
        <div className="researcher-sign-up-form-field">
            <label className="researcher-sign-up-form-field-label">{props.label}</label>
            <select required className={`researcher-sign-up-form-field-input dropdown ${!isActive ? 'placeholder-style' : ''}`} name={props.name} value={props.value} onChange={(event) => handleChange(event.target.value)} defaultValue="-1">
                {props.placeholder &&
                    <option className="new-gray-text" disabled
                        value="-1"> {props.placeholder}
                    </option>
                }
                {props.options.map((option, index) => {
                    return <option key={index} value={option}>{option}</option>
                })}
            </select>
            {props.errorMessage && <div className="researcher-sign-up-form-field-error">{props.errorMessage}</div>}
        </div>

    )
}

function TermsCheckbox(props) {
    return (
        <div className="researcher-sign-up-terms-checkbox-and-error-container">
            <div className="researcher-sign-up-terms-checkbox">
                <input className="researcher-form-checkbox researcher-checkbox-color" type="checkbox" id="termsCheckbox" name="termsCheckbox" value={props.agreedToTerms} onChange={(event) => props.setAgreedToTerms(event.target.checked)} />
                <label htmlFor="termsCheckbox" className="researcher-sign-up-terms-checkbox-label"> I agree to Despark's <a href="https://www.despark.io/legal/researcher-terms-of-service" className="white-link h-margin" target="_blank">Terms of Service</a> </label>
            </div>
            {props.errorMessage && <div className="researcher-sign-up-form-field-error">{props.errorMessage}</div>}
        </div>

    )
}

export { FormField, DropdownQuestion, TermsCheckbox };